import { baseUrl } from '@/shared/constants'
import axios from 'axios'
import { CreatePaymentDTO, TransactionStatus, TransactionStatusDTO } from './types'
import { GetUpdateProgressPaymentLinkResponse } from './types'

// export const postCreatePayment = async (token: string, data: SteamPaymentFormData) => {
//   const response = await axios.post(
//     `${baseUrl}/payment/create-payment/`,
//     {
//       country: data.country?.value,
//       currency: data.currency?.value,
//       payment_method: 2,
//       amount: Number(data.amount?.value),
//       login: data.login?.value,
//       amount_usd: Number(data.amount_usd?.value),
//     },
//     {
//       headers: {
//         'Content-Type': 'application/json',
//         Authorization: `Bearer ${token}`,
//       },
//     }
//   )
//   return response.data
// }

export const getPaymentInfo = async (token: string) => {
  const response = await axios.get(`${baseUrl}/payment/info`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })
  return response.data
}

export const getCurrencyRate = async (token: string) => {
  const response = await axios.get(`${baseUrl}/payment/rates`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })
  return response.data
}

export const getHistory = async (token: string) => {
  const response = await axios.get(`${baseUrl}/payment/history`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })
  return response.data
}

export const getUpdateProgressInvoiceLink = async (token: string): Promise<GetUpdateProgressPaymentLinkResponse> => {
  const response = await axios.get(`${baseUrl}/payment/scoring`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })
  return response.data
}
export const getTransactionStatus = async (params: TransactionStatusDTO): Promise<TransactionStatus> => {
  const response = await axios.get(`${baseUrl}/ton_payment/transaction-status?tx_id=${params.tx_id}`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${params.token}`,
    },
  })
  return response.data
}
export const postCreatePayment = async (params: CreatePaymentDTO) => {
  const response = await axios.post(
    `${baseUrl}/ton_payment/create-payment/`,
    {
      key_id: params.id,
      amount: params.amount,
      tx_id: params.tx_id,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${params.token}`,
      },
    }
  )
  return response.data
}

export const getScoringInvoice = async (token: string): Promise<GetUpdateProgressPaymentLinkResponse> => {
  const response = await axios.get(`${baseUrl}/payment/scoring`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })
  return response.data
}
